import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { BinderComponent } from '@/landmark/binder/binder.component';
import { AssembliesOperationsComponent } from '@/landmark/operations/assemblies/assemblies.component';
import { AssemblyTableComponent } from '@/landmark/operations/assemblies/assemblies/assembly-table/assembly-table.component';
import { OfficeTemplatesComponent } from '@/landmark/operations/assemblies/office-templates/office-templates.component';
import { PlanPricingComponent } from '@/landmark/operations/plan-pricing/plan-pricing.component';
import { FoundersComponent } from '@/landmark/operations/founders/founders.component';
import { NavLockGuard } from '@/services/app/nav-guard.guard';
import { LogoutComponent } from '@/pages/auth/logout';
import { BankSettingsComponent } from '@/landmark/operations/bank-settings/bank-settings.component';
import { LenderContactsComponent } from '@/landmark/operations/bank-settings/lender-contacts/lender-contacts.component';
import { DrawSchedulesComponent } from '@/landmark/operations/bank-settings/draw-schedules/draw-schedules.component';
import { BinderListComponent } from '@/landmark/operations/binder-list/binder-list.component';
import { EmbedComponent } from '@/layout/components/embed.component';
import { NewBinderContainerComponent } from '@/landmark/binder/new-binder-container.component';
import { authGuardFn } from '@auth0/auth0-angular';
import { RedirectToEmbedEditComponent, RedirectToEmbedNewComponent, RedirectToEmbedNewHigharcComponent } from '@/utility/redirects';
import AppDirectoryComponent from '@/landmark/directory/app-directory.component';
import { AppPermsComponent } from '@/landmark/operations/permissions/perms-screen.component';
import { ContentGroupLinkerComponent } from '@/landmark/content-groups/content-group-linker.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },
  {
    path: 'app',
    component: AppLayout,
    children: [
      { path: '', data: { breadcrumb: 'E-Commerce Dashboard' }, loadComponent: () => import('./app/pages/dashboard/ecommercedashboard').then((c) => c.EcommerceDashboard) },
      { path: 'dashboard-banking', data: { breadcrumb: 'Banking Dashboard' }, loadComponent: () => import('./app/pages/dashboard/bankingdashboard').then((c) => c.BankingDashboard) },
      { path: 'pages', data: { breadcrumb: 'Pages' }, loadChildren: () => import('./app/pages/pages.routes') },
      { path: 'profile', data: { breadcrumb: 'User Management' }, loadChildren: () => import('@/pages/usermanagement/usermanagement.routes') },
      { path: 'signatures', data: { breadcrumb: 'Signature Sessions' }, loadComponent: () => import('@/landmark/signature-sessions/sessions-list.component').then((c) => c.SessionsListComponent) },
      { path: 'test', data: { breadcrumb: 'Dev Test' }, loadComponent: () => import('@/landmark/plan-browser/plan-browser.component').then((c) => c.PlanBrowserComponent) },
      {
        path: 'content-groups',
        data: { breadcrumb: 'Content Groups' },
        component: ContentGroupLinkerComponent,
      },
      {
        path: 'binders',
        data: { breadcrumb: 'Binders' },
        children: [
          { path: '', component: BinderListComponent },
          { path: 'edit/:binderId', component: BinderComponent, data: { breadcrumb: 'Binder Detail' } },
          // { path: ':searchTerm', component: BinderListComponent, data: { breadcrumb: 'Search Result' } }
          { path: 'new/:clientId', component: NewBinderContainerComponent, data: { breadcrumb: 'New Binder' } },
        ],
        canActivate: []
      },
      
      {
        path: 'ops',
        data: { breadcrumb: 'Operations' },
        children: [
          // { path: '', component: OperationsComponent },
          // { path: 'lenders', component: LendersComponent, data: { breadcrumb: 'Lenders' } },
          {
            path: 'banksettings', component: BankSettingsComponent, data: { breadcrumb: 'Bank Settings' },
            children: [
              { path: '', redirectTo: 'lendercontacts', pathMatch: 'full' },
              { path: 'lendercontacts', component: LenderContactsComponent, data: { breadcrumb: 'Lender Contacts' } },
              { path: 'drawschedules', component: DrawSchedulesComponent, data: { breadcrumb: 'Draw Schedules' } },
            ]
          },
          // { path: 'plans', component: PlanManagementComponent, data: { breadcrumb: 'Plans' } },
          { path: 'binders', component: BinderListComponent, data: { breadcrumb: 'Binders' } },
          {
            path: 'assemblies', component: AssembliesOperationsComponent, data: { breadcrumb: 'Assemblies' },


            children: [
              { path: '', redirectTo: 'assemblies', pathMatch: 'full' },
              { path: 'assemblies', component: AssemblyTableComponent, data: { breadcrumb: 'Assemblies' } },
              { path: 'officetemplates', component: OfficeTemplatesComponent, data: { breadcrumb: 'Office Templates' } },
            ]

          },
          { path: 'planpricing', component: PlanPricingComponent, data: { breadcrumb: 'Plan Pricing' } },
          { path: 'founders', component: FoundersComponent, data: { breadcrumb: 'Founders' }, canDeactivate: [NavLockGuard] },
          { path: 'users', component: AppDirectoryComponent, data: { breadcrumb: 'User Settings' } },
        ],
        canActivate: []
      },
      // --- LEGACY /app/* redirects to canonical /embed/binders/* ---
      // /app/new-higharc/:builderId/:haId/:clientId  ->  /embed/binders/new/:clientId?builderId&planId
      { path: 'new-higharc/:builderId/:haId/:clientId', component: RedirectToEmbedNewHigharcComponent },

      // /app/new/:clientId  ->  /embed/binders/new/:clientId  (+preserve ?linkmode=true)
      { path: 'new/:clientId', component: RedirectToEmbedNewComponent },

      // /app/edit/:binderId -> /embed/binders/edit/:binderId
      { path: 'edit/:binderId', component: RedirectToEmbedEditComponent },
      { path: 'permissions', component: AppPermsComponent, data: { breadcrumb: 'Permissions' } },
    ],
    canActivate: [authGuardFn]
  },
  {
    path: 'embed',
    component: EmbedComponent,
    children: [
      {
        path: '**',
        component: EmbedComponent,
        canActivate: []
      }
    ]
  },
  { path: 'logout', component: LogoutComponent },
  // { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
  { path: 'notfound', loadComponent: () => import('./app/pages/error/notfound.component').then((c) => c.NotfoundComponent) },
  { path: '**', redirectTo: '/notfound' }
];
